<template>
  <div class="container-lang-switcher">
    <el-select v-model="lang" @change="handleLangChange()">
      <span v-for="(item, i) in options" :key="i">
        <el-option :label="item.label" :value="item.value">
          <span>{{ item.label }}</span>
        </el-option>
      </span>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'LangSwitcher',
  data() {
    return {
      lang: localStorage.getItem('lang') || 'it',
      namespaceKey: this.$route.path.replaceAll('/', '')
    }
  },
  computed: {
    options() {
      return [
        {
          value: 'it',
          label: this.$t('userData.italian')
        },
        {
          value: 'en',
          label: this.$t('userData.english')
        }
      ]
    }
  },
  methods: {
    handleLangChange() {
      localStorage.setItem('lang', this.lang)
      this.$i18n.locale = this.lang
      // this.locateLang = this.lang
      // window.location.reload();
    }
  }
}
</script>

<style lang="scss" scoped>
.container-lang-switcher {
  width: 100px;
  height: 25px;

  .el-input {
    .el-input__inner {
      height: 25px;
    }

    .el-input__suffix {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.lang-switcher {
  padding: 2px 10px 2px 10px;
  font-family: "Montserrat-Regular",sans-serif;
  font-size: 12px;
  border-radius: 3px;
  border: 1px solid #dcdfe6;
}
</style>

<style lang="scss">
  .container-lang-switcher {
  width: 100px;
  height: 25px;

  .el-input {
    .el-input__inner {
      height: 25px;
    }

    .el-input__suffix {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
